import template from './affiliates.html';
import './affiliates.scss';

const component = {
	bindings: {
		discount: '=',
	},
	template,
	controller: function(
		Affiliate,
		$scope,
	) {
		"ngInject"

		this.affiliates = Affiliate.list;

		$scope.$on('affiliate:list', (e, list) => {
			this.affiliates = Affiliate.list;
		})

		this.toggleAffiliate = () => {
			if (this.discount !== undefined) {
				this.discount = 0;
				this.affiliates.forEach(affiliate => {
					if (affiliate.enabled) {
						this.discount += affiliate.discount;
					}
				});
			}
		}
	}
};

export default component;



// WEBPACK FOOTER //
// ./app/components/affiliates/affiliates.component.js